import React, { useCallback, useEffect, useState, useRef } from "react";
import { EquipmentAPIs } from "../../service/api-service";
import {
  Box,
  Link,
  Typography,
  Backdrop,
  useMediaQuery,
  CircularProgress,
  Grid,
  Modal,
  IconButton,
  Tooltip,
} from "@mui/material";
import gemArrow from "assets/images/gem-arrow.png";

import { useDispatch, useSelector } from "react-redux";
import { setalertMessagetype, setalertMessage } from "redux/redux-slice";
import { IApiResponseRawData, IStoreValue } from "utils/types";

import "./styles.scss";

import MainLayout from "../../layouts/MainLayout";
import moment from "moment";
import { useParams } from "react-router-dom";

import EquipmentItem from "components/equipment-item/EquipmentItem";

import ProfilePic from "./../../assets/images/dummy-profile-pic.jpeg";
// import ShareIcon from './../../assets/images/share-ico.png';
import ShareIcon from "./../../assets/images/share.png";
import CloseIcon from "@mui/icons-material/Close";
import copyClipboard from "assets/images/copy-clipboard.png";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  FacebookMessengerIcon,
} from "react-share";
import QRShareModal from "components/common/ShareYard/SharableQrCode";
import UrlCopiedModal from "components/common/ShareYard/UrlCopiedModal";

var base_url = window.location.origin;
const base_url_link = base_url + "/Testing-dozers/Landran/Punjab/0/512/603";

const loginstyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
};

const ShareRentalYard = () => {
  const matchesDesktop = useMediaQuery("(min-width:769px)");
  const matchesMobileX = useMediaQuery("(max-width:425px)");
  const dispatch = useDispatch();

  const params = useParams();

  const [Total, setTotal] = React.useState(0);
  const [Equips, setEquips] = React.useState([]);
  const [Page, setPage] = React.useState(0);

  const [loading, setloading] = React.useState(false);
  //const [loadmore, setloadmore] = React.useState(false);
  const [OwnerInfo, setOwnerInfo] = React.useState({});
  const [ShareYardCopyPopup, setShareYardCopyPopup] = React.useState(false);
  const [ShareYardPopup, setShareYardPopup] = useState<boolean>(false);
  const [ShareLink, setShareLink] = React.useState("");
  const AuthUserId = useSelector(
    (state: IStoreValue) => state.equipmentReducer.Authuser
  );

  const today = moment().format("YYYY-MM-DD");
  const MyEquip = async (
    user_id: string,
    equipUser: string,
    new_page: number
  ) => {
    try {
      setloading(true);

      const bodyParams = {
        page: new_page,
        share_user_id: parseInt(equipUser ?? user_id),
        equip_list_type: params.type ? params.type : "rent",
      };
      if (AuthUserId) {
        bodyParams["user_id"] = AuthUserId;
      } else {
        bodyParams["user_id"] = undefined;
      }
      if (user_id === equipUser) {
        bodyParams["is_private"] = true;
      }
      const OfficeTrailerData = await EquipmentAPIs.MyRentalyard(bodyParams);

      if (OfficeTrailerData["type"] == "RXSUCCESS") {
        let equip = OfficeTrailerData["data"];
        let total = OfficeTrailerData["total"];
        // by GD 11 jan 2024 due to error in share rental yard
        // setOwnerInfo(OfficeTrailerData['UserInfo'])
        // end by
        setOwnerInfo(OfficeTrailerData["user"]);
        setShareLink(OfficeTrailerData["share_link"]);
        let old_data = Equips;
        let new_data = [...old_data, ...equip];
        setTotal(total);
        setEquips(new_data);
        setloading(false);
        setPage(new_page);
      } else {
        dispatch(setalertMessage(OfficeTrailerData["message"]));
        dispatch(setalertMessagetype("error"));
        setloading(false);
        return false;
      }
    } catch (err) {
      console.log(err);
      setloading(false);
    }
  };

  const HandleRentalYardPagination = () => {
    let old_page = Page;
    let new_page = old_page + 1;
    MyEquip(params.userId, params.equipUser, new_page);
  };

  const HandleShareYard = () => {
    let share_link = ShareLink;

    navigator.clipboard.writeText(share_link);
    //alert("Copied the text: " + share_link);
    setShareYardCopyPopup(true);
  };

  useEffect(() => {
    // let auth_user = localStorage.getItem('token-info');
    // if (auth_user != 'undefined') {
    //   auth_user = JSON.parse(auth_user);
    //   if (auth_user != null && auth_user) {
    //     MyEquip(params.id, Page)
    //     window.scrollTo(0, 0);
    //   }
    // }

    MyEquip(params.userId, params.equipUser, Page);
    window.scrollTo(0, 0);
  }, [AuthUserId]);

  return (
    <>
      <MainLayout>
        {loading && (
          <div>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        )}

        <Box className="rentyrd-main">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                borderBottom: "2px solid #faa61a",
                pb: 2,
                mb: 2,
                width: "100%",
              }}
            >
              {/* Left Section: Profile Picture & Name */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  component="img"
                  src={OwnerInfo["profile_pic"] || ProfilePic}
                  alt="profile"
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #faa61a",
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "GothamBold !important",
                    fontSize: "clamp(20px, 3vw, 35px) !important",
                    color: "#fff",
                  }}
                >
                  {OwnerInfo["first_name"]
                    ? `${OwnerInfo["first_name"]}'s`
                    : "NA"}{" "}
                  <Box component="span" sx={{ color: "#faa61a" }}>
                    Rental Yard
                  </Box>
                </Typography>
              </Box>

              {/* Right Section: Copy & Share Buttons */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  mt: { xs: 2, sm: 0 },
                }}
              >
                {/* Copy to Clipboard Icon */}
                <Tooltip title="Copy link" placement="top">
                  <Box
                    component="span"
                    onClick={HandleShareYard}
                    sx={{
                      width: 26,
                      height: 26,
                      backgroundColor: "#faa61a",
                      maskImage: `url(${copyClipboard})`,
                      maskSize: "cover",
                      maskRepeat: "no-repeat",
                      WebkitMaskImage: `url(${copyClipboard})`,
                      WebkitMaskSize: "cover",
                      WebkitMaskRepeat: "no-repeat",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>

                {/* Share Button */}
                <Box
                  onClick={() => setShareYardPopup(true)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer",
                  }}
                >
                  <Box
                    component="img"
                    src={ShareIcon}
                    alt="Share"
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "GothamBold !important",
                      color: "#faa61a",
                      fontSize: "clamp(18px, 3vw, 25px) !important",
                      textTransform: "capitalize",
                    }}
                  >
                    Share rental yard
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Grid
              container
              spacing={4}
              className="equipment-grid"
              sx={{ marginTop: "5px", marginBottom: "20px" }}
            >
              {Total > 0 &&
                Equips.map((equipment) => (
                  <Grid
                    item
                    xs={matchesDesktop ? 4 : matchesMobileX ? 12 : 12}
                    sm={6}
                    md={6}
                    lg={4}
                    key={equipment.id}
                    sx={{ display: "flex", justifyContent: "center" }}
                    className="equipment-grid-item"
                  >
                    <EquipmentItem item={equipment} type={"equipDetail"} />
                  </Grid>
                ))}

              {/* {loading && (
                <CircularProgress />
              )} */}

              {Total == 0 && (
                <Box
                  className="equipments-wrapper no-data"
                  sx={{ textAlign: "center", marginLeft: "35px !important" }}
                >
                  No equipment found.
                </Box>
              )}
            </Grid>
            <Box className="seemore-box">
              {Total > Equips.length && (
                <Link
                  className="btn-load-more"
                  onClick={HandleRentalYardPagination}
                >
                  {"See More"}
                  <img
                    src={gemArrow}
                    alt="GoEquipMe"
                    className="gem-arrow arrow-load-more"
                  />
                </Link>
              )}
            </Box>
          </Box>
        </Box>

        {ShareYardCopyPopup && (
          <UrlCopiedModal
            onClose={() => setShareYardCopyPopup(false)}
            open={ShareYardCopyPopup}
          />
        )}

        {ShareYardPopup && (
          <QRShareModal
            open={ShareYardPopup}
            onClose={() => setShareYardPopup(false)}
            userName={OwnerInfo?.["first_name"] || "Unknown"}
            userImgUrl={OwnerInfo?.["profile_pic"] || ProfilePic}
            qrUrl={ShareLink}
          />
        )}
      </MainLayout>
    </>
  );
};
export default ShareRentalYard;
